import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { getSeoFooterData } from '../../utils/plpMetaInfo';
import { getRuntimeBannersFlag, getRuntimeBannersUrlList } from '../../Flags/selectors';
import _isEmpty from 'lodash/isEmpty';

const mapStateToClass = {
  minimisedClasses: ['seo-dropdown-content close-seo', 'ic-Chevron-down'],
  normalClasses: ['seo-dropdown-content', 'ic-Chevron-up']
};

class SeoDropdown extends PureComponent {
  constructor(props) {
    super(props);
    const { minimizeHtmlContent = true } = props;
    this.state = {
      isMinimised: minimizeHtmlContent
    };
  }

  toggleHTMLContent = () => {
    this.setState(prevState => {
      return { isMinimised: !prevState.isMinimised };
    });
  };

  render() {
    const {
      metaData = [],
      isIndexMobile = false,
      overrideFooterSeoContent = '',
      runtimeBanners,
      isMsite = false,
      isRuntimeBannerPage
    } = this.props;
    const { minimisedClasses, normalClasses } = mapStateToClass;
    const htmlTitle = 'More about shopping from AJIO';
    let dataType = 'bottomDesc';
    if (isRuntimeBannerPage && !isMsite) {
      dataType = 'bottomDescription';
    }
    let htmlContent = getSeoFooterData(metaData, dataType, isRuntimeBannerPage ? 'ON' : 'OFF');
    let topBrands;
    let topSearches;
    let trendingBlogs;
    let topCategories;
    if (isRuntimeBannerPage && !isMsite) {
      topBrands = getSeoFooterData(metaData, 'topBrands', runtimeBanners);
      topSearches = getSeoFooterData(metaData, 'topSearches', runtimeBanners);
      trendingBlogs = getSeoFooterData(metaData, 'trendingBlogs', runtimeBanners);
      topCategories = getSeoFooterData(metaData, 'topCategories', runtimeBanners);
    }
    // let [contentClasses, chevronStateClass] = this.state.isMinimised
    // ? minimisedClasses
    // : normalClasses;
    // let titleClasses = 'seo-dropdown-title';
    let [contentClasses] = normalClasses;
    if (isIndexMobile) {
      titleClasses = `${titleClasses} index-mobile-title-seo`;
      contentClasses = `${contentClasses} index-mobile-content-seo`;
    }
    if (overrideFooterSeoContent) {
      htmlContent = overrideFooterSeoContent;
    }
    const seoDropdown = htmlContent ? (
      <div className="seo-dropdown" tabIndex={0}>
        {/* <div className={titleClasses} onClick={this.toggleHTMLContent} aria-label={htmlTitle} tabIndex={0}>
          {htmlTitle}
          <span className={chevronStateClass} />
        </div> */}
        {!_isEmpty(topSearches) && Array.isArray(topSearches) && (
          <div className="popular-container">
            <div className="seo-header-container">
              <h2>Popular Search</h2>
              <hr className="line" />
            </div>
            <div className="popular-item">
              {topSearches.map(item => (
                <a href={item.link}>
                  <span className="blockSpan">{item.name} | </span>
                </a>
              ))}
            </div>
          </div>
        )}
        {!_isEmpty(topBrands) && Array.isArray(topBrands) && (
          <div className="popular-container">
            <div className="seo-header-container">
              <h2>Popular Brands</h2>
              <hr className="line" />
            </div>
            <div className="popular-item">
              {topBrands.map(item => (
                <a href={item.link}>
                  <span className="blockSpan">{item.name} | </span>
                </a>
              ))}
            </div>
          </div>
        )}
        {!_isEmpty(topCategories) && Array.isArray(topCategories) && (
          <div className="popular-container">
            <div className="seo-header-container">
              <h2>Popular Categories</h2>
              <hr className="line" />
            </div>
            <div className="popular-item">
              {topCategories.map(item => (
                <a href={item.link}>
                  <span className="blockSpan">{item.name} | </span>
                </a>
              ))}
            </div>
          </div>
        )}

        {!_isEmpty(trendingBlogs) && Array.isArray(trendingBlogs) && (
          <div className="popular-container">
            <div className="seo-header-container">
              <h2>Trending Blogs</h2>
              <hr className="line" />
            </div>
            <div className="popular-item">
              {trendingBlogs.map(item => (
                <a href={item.link}>
                  <span className="blockSpan">{item.name} | </span>
                </a>
              ))}
            </div>
          </div>
        )}
        {/* {topBrandsContent && (
          <div className={contentClasses} dangerouslySetInnerHTML={{ __html: topBrandsContent }} aria-label={topBrandsContent} tabIndex={0}/>
        )}
        {topSearchesContent && (
          <div
            className={contentClasses}
            dangerouslySetInnerHTML={{ __html: topSearchesContent }}
            aria-label={topSearchesContent}
            tabIndex={0}
          />
        )} */}
        <div className={contentClasses} dangerouslySetInnerHTML={{ __html: htmlContent }} aria-label={htmlContent} tabIndex={0}/>
      </div>
    ) : null;
    return seoDropdown;
  }
}

const mapStateToProps = state => {
  const { seoMetaData = {}, flags = {} } = state;
  const { metaElementData = {} } = seoMetaData;
  return {
    metaData: metaElementData,
    runtimeBanners: getRuntimeBannersFlag(flags),
    runtimeBannersUrlList: getRuntimeBannersUrlList(flags),
    isRuntimeBannerPage: state.bannerInfo.isRuntimeBannerPage
  };
};

export default connect(mapStateToProps)(SeoDropdown);
